export const isQuotationRoot = (row) => {
  if (row.isRoot != null) return row.isRoot === true || Number(row.isRoot) === 1;
  const code = String(row.codeNo || "").trim();
  if (row.rootCode != null) return String(row.rootCode).trim() === code;
  return code.endsWith("0000");
};
